import { useMutation } from '@tanstack/react-query';
import { DEPRECATED_QUERY_KEYS, queryClient } from '@src/query';
import { ApiError } from '@src/services/api';
import { updateWidget } from './api';
import { ApiTypes, WidgetView } from 'common';

export const useMutationChangeWidgetLockStatus =  () =>
  useMutation<
    WidgetView,
    ApiError,
    {
      id: string;
      widget: ApiTypes.WidgetUpdate;
    }
  >({
    mutationFn: ({ id, widget }) => updateWidget(id, switchWidgetLockStatus(widget)),
    onSuccess: async () => {
      const key = [DEPRECATED_QUERY_KEYS.WIDGETS];
      queryClient.invalidateQueries({ queryKey: key });
      queryClient.refetchQueries({ queryKey: key });
    },
  });

const switchWidgetLockStatus = (widget: ApiTypes.WidgetUpdate): ApiTypes.WidgetUpdate => {
  return {
    ...widget,
    is_locked: !widget.is_locked,
  };
}
